define(
	'C3.ShoppingExtensions.LoginRegister.Login.Model',
	[
		'SCModel',
		'Utils'
	],
	function(SCModelComponent, Utils){
		'use strict';

		var SCModel = SCModelComponent.SCModel;

		function LoginRegisterLoginModel() {
			SCModel.call(this);

			// Define properties of the model.
			this.urlRoot = function() {
				return Utils.getAbsoluteUrl(
					getExtensionAssetsPath("services/LoginRegister.Login.Service.ss")
				)
			}

			this.validation = function() {
				return {
					email: {
			            required: true,
			            pattern: 'email',
			            msg: Utils.translate('Please enter a valid email address.')
			        },
			        password: {
			            required: true,
			            msg: Utils.translate('Please enter a valid password.')
			        }
				}
			}
		}

		LoginRegisterLoginModel.prototype = Object.create(SCModel.prototype);

		LoginRegisterLoginModel.prototype.constructor = LoginRegisterLoginModel;

		// Return the AMD constructor.
		return LoginRegisterLoginModel;
	}
);
